import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { EguardMainModule } from './main/main.module';
import { EguardSplashScreenService } from './core/services/splash-screen.service';
import { EguardConfigService } from './core/services/config.service';
import { CommonModule } from './main/content/common.module';
import { NgcFloatButtonModule } from 'ngc-float-button';
import { HeaderTitleService } from './services/header-title.service';
import { AngularFontAwesomeModule } from 'angular-font-awesome';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'dashbard',
        pathMatch: 'full'
    }
];


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, { useHash: true }),
        SharedModule,
        PerfectScrollbarModule,
        EguardMainModule,
        CommonModule,
        NgcFloatButtonModule,
        ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
        AngularFontAwesomeModule
    ],
    providers: [
        EguardSplashScreenService,
        EguardConfigService,
        HeaderTitleService
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [
        NgcFloatButtonModule
    ]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts